export enum ModalQueueItemType {
  Recruit = 'congratulate-recruit',
  Init = 'congratulate-init',
  Gift = 'common-gift',
  Coupon = 'order-coupon-gift'
}

export enum EnumRegisterModalNames {
  Topic = 'topic-modal',
  Gift = 'common-gift-modal',
  Coupon = 'order-coupon-gift-modal'
}

export enum ModalQueueItemCode {
  Recruit = 50100,
  Init = 50101,
  Gift = 50102,
  Coupon = 50103
}
